import { render, staticRenderFns } from "./aAmsPort.vue?vue&type=template&id=25f828d5&"
import script from "./aAmsPort.vue?vue&type=script&lang=js&"
export * from "./aAmsPort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f828d5')) {
      api.createRecord('25f828d5', component.options)
    } else {
      api.reload('25f828d5', component.options)
    }
    module.hot.accept("./aAmsPort.vue?vue&type=template&id=25f828d5&", function () {
      api.rerender('25f828d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/aAmsPort.vue"
export default component.exports